<template>
  <div>
<!--    <page-header></page-header>-->
<!--     <popup-header></popup-header>-->
    <router-view class="pb-14"></router-view>
    <!-- 신청하기 버튼 -->
    <application-btn v-if="appBtnShow"></application-btn>
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
import ApplicationBtn from '@/components/application/buttons/ApplicationBtn.vue';

export default {
  computed: {
    appBtnShow() {
      return this.$route.name === 'approvalLine';
    },
  },

  components: {
  //  PageHeader,
    ApplicationBtn,
  },
};
</script>
